export default __webpack_public_path__ + "static/media/avatar_ali4.27d1f764.mp3";